module.exports = __webpack_public_path__ + "static/aws-developer-8bc681b8e27aa1e1849c3699e9733e2f.png";